import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router,  Routes, Route, Link } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Sidebar from "./components/Sidebar/Sidebar";
import Close from "./assets/close.png"
  import HeroSection from "./components/HeroSection/HeroSection";
  import About from "./components/About/About";


function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

 
 

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  return (
    <Router>
      <Navbar
      isScrolled={isScrolled}
      setIsScrolled={setIsScrolled}
         toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
      />
       <Sidebar
          isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      {isSidebarOpen && <div className="overlay" onClick={toggleSidebar}></div>}
      {isSidebarOpen && (
        <img
          src={Close}
          onClick={() => setIsSidebarOpen(false)}
          className="closeIcon"
        />
      )}
      <Routes>
       
         <Route path="/" exact element={<HeroSection  />} />
         <Route path="/" exact element={<About />} />

      </Routes>
 
     </Router>
  );
}

export default App;